import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import FilterImg from "../../Assets/images/filter.svg";
import CloseImg from "../../Assets/images/close.svg";
import EditImg from "../../Assets/images/edit.svg";
import FilterEditImg from "../../Assets/images/filter-edit.svg";
import TickImg from "../../Assets/images/tick.svg";
import CloseWhiteImg from "../../Assets/images/black-close.svg";
import { Checkbox, Col, Row, Collapse } from "antd";
import { Select } from "antd";
import { fetchLandDescriptions } from "../../Utils/landgetapi";
import axios from "axios";
import { post } from "../../Services/Api";
import { setSelectedValues } from "../../Redux/SelectedSpace";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../Components/Loading";
import { get } from "../../Services/Api";
import Settings from "../../Assets/images/settings.svg";
import InfoGreen from "../../Assets/images/info-green.svg";
import TickImgNew from "../../Assets/images/tick-new.svg";
import NoBackgroundImage from "../../Assets/images/no_background_image2.png";
import SearchIconImg from "../../Assets/images/search.svg";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

import AdminSidebar from "../../Components/AdminSidebar";
import { setPlanningBuildPayload } from "../../Redux/PlanningSpaces";
import { notification } from "antd";

const { Panel } = Collapse;
const PlanningBuildFilter = () => {
    // 
    const [selectedCategories, setSelectedCategories] = useState([]);

    const handleCategoryClick = (category) => {
      setSelectedCategories((prev) =>
        prev.includes(category)
          ? prev.filter((item) => item !== category) // Remove if already selected
          : [...prev, category] // Add if not selected
      );
    };
    // console.log("selectedCategories::",selectedCategories);
    


    // 
  const admin_firstname = localStorage.getItem("firstName");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedValues = useSelector(
    (state) => state.selectedSpace.selectedValues
  );
  const [apiData, setApiData] = useState([]);
  const [landUses, setLandUses] = useState([]);
  const [landdescriptionResponse, setLanddescriptionResponse] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [userCheck, setUserCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [searchSpace, setSearchSpace] = useState("");
  const [filteredlandUsesQuery, setFilteredLandUses] = useState([]);

  const [landUses_category, setLandUses_category] = useState([]);
  const [landdescriptionResponse_category, setLanddescriptionResponse_category] = useState([]);

  const openNotification = (type, message, description) => {
    notification[type]({
      message,
      description,
      placement: "topRight",
    });
  };

 
  



  const toggleDropdown = (filterName) => {
    setActiveDropdown((prev) => (prev === filterName ? null : filterName));
  };

  useEffect(() => {
    // const userId = localStorage.getItem("adminId");
    const userId = localStorage.getItem("roles");
    // setUserCheck(userId === '1');
    setUserCheck(userId === "admin");
  }, []);

  // console.log("selectedValues From page before dashboard::",selectedValues);

  useEffect(() => {
    setLoading(true);
    const loadLandDescriptions = async () => {
      try {
        const response = await get("landdescription");
        const landResponse = response.data;

        setLanddescriptionResponse(landResponse);

        // console.log("landResponse:", landResponse);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching land description data:", error);
      }
    };

    loadLandDescriptions();
  }, []);
  // console.log("landdescriptionResponse::",landdescriptionResponse);
  

  // **

  useEffect(() => {
    setLoading(true);
    const loadLandDescriptions = async () => {
      try {
        // const response = await get("http://192.168.96.120:5000/apis/listcategory");
        const response = await get("listcategory");
        const data = response.data.categories;

        setLanddescriptionResponse_category(data)
        setFilteredLandUses(data);
        

         // Flatten land_uses and extract land_use_name
      // const uniqueLandUses = Array.from(
      //   new Set(
      //     data.flatMap((category) =>
      //       category.land_uses.map((landUse) => landUse.land_use_name)
      //     )
      //   )
      // );

      // setLandUses_category(uniqueLandUses);
      // setLanddescriptionResponse_category(uniqueLandUses);

        // console.log("landResponse:", landResponse);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching land description data:", error);
      }
    };

    loadLandDescriptions();
  }, []);
  // console.log("landdescriptionResponse_category::",landdescriptionResponse_category);
  // console.log("landUses_category::",landUses_category);
  
  

  // **//

  useEffect(() => {
    setLoading(true);
    const loadLandDescriptions = async () => {
      try {
        const response = await get("landdescription");
        const data = response.data;
        setApiData(data);

        const uniqueLandUses = Array.from(
          new Set(data.map((item) => item["Land Use"]))
        );
        setLandUses(uniqueLandUses);
        // setFilteredLandUses(uniqueLandUses);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching land description data:", error);
      }
    };
    loadLandDescriptions();
  }, []);

  // console.log("filteredlandUsesQuery::",filteredlandUsesQuery);

  // console.log("landdescription",landUses);
  // console.log("apiData",apiData);
  
  

  const handleSpaceSearch = (searchQuery) => {
    setSearchSpace(searchQuery);

    if (!searchQuery.trim()) {
      setFilteredLandUses(landdescriptionResponse_category);
      return;
    }

    // const filteredlandUsesQuery = landUses.filter((land) =>
    //   land.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    const filteredlandUsesQuery = landdescriptionResponse_category.map((category)=>({
      ...category,
      land_uses: category.land_uses.filter((land)=>
      land.land_use_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    }))
    .filter((category)=>category.land_uses.length > 0)

    setFilteredLandUses(filteredlandUsesQuery);
  };

  const getOptionsByLandUse = (landUse) => {
    const filteredData = apiData.filter((item) => item["Land Use"] === landUse);
    return filteredData.map((item) => ({
      value: item.Description,
      label: item.Description,
    }));
  };

  // const {selectedValues = []} = location.state || {};

  const handleSelctingSpaceFromFilter = (checkedValues) => {
    // console.log("checkedValues::",checkedValues);

     // Ensure selectedValues is an array
  let updatedValues = [...selectedValues]; // Clone selectedValues to avoid mutating directly
  
  // Check if checkedValues is an array (multiple values) or a single value
  const valuesToProcess = Array.isArray(checkedValues) ? checkedValues : [checkedValues];

  valuesToProcess.forEach((value) => {
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues = updatedValues.filter((item) => item !== value);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
  });

  // console.log("updatedValues::", updatedValues);
    
    // dispatch(setSelectedValues(checkedValues));
    dispatch(setSelectedValues(updatedValues));
  };
  // console.log("selectedValues:::!!!!:::",selectedValues);
  

  const handleRemoveValue = (value) => {
    dispatch(
      setSelectedValues(selectedValues.filter((item) => item !== value))
    );
  };

  // const handleFormChange = (field, value)=>{
  //     setFormValues(preValues=>({
  //         ...preValues,
  //         [field]: value
  //     }))
  // }



  const handleFormChange = (filterName, field, value) => {
    if (/^\d*\.?\d*$/.test(value)) {
      setFormValues((prevValues) => ({
        ...prevValues,
        [filterName]: {
          ...prevValues[filterName],
          [field]: value,
        },
        
      }));
    }
  };

  const renderFilterForm = (filterName) => {
    // const matchingLandUse = landdescriptionResponse.find(
    //   (item) => item["Land Use"] === filterName
    // );
    // const matchingLandUse = landdescriptionResponse_category.find((category) =>
    //   category.land_uses.some((landUse) => landUse.land_use_name === filterName)
    // );
    const matchingLandUse = 
    landdescriptionResponse_category
      ?.flatMap((category) => category.land_uses || []) // Flatten land_uses arrays
      .find((landUse) => 
        landUse.land_use_name?.trim().toLowerCase() === filterName?.trim().toLowerCase() // Case-insensitive match
      );
      // console.log("matchingLandUse::",matchingLandUse);
      
      // console.log("landdescriptionResponse_category Inside Render Form:", landdescriptionResponse_category);
      // console.log("filterName Inside Render Form:", filterName);
      // console.log(
      //   "All Land Use Names:",
      //   landdescriptionResponse_category
      //     ?.flatMap((category) => category.land_uses || []) 
      //     .map((landUse) => landUse.land_use_name) 
      // );
    return (
      <div className="selected-filters" key={filterName}>
        <div className="mb-2">
          <h6>{filterName}</h6>
          <p
          className="mb-0"
          style={{ fontSize: "11px", color: "#00000080" }}
        > 
          {matchingLandUse?.copied_landuse !== null &&
          "copied from " +
          matchingLandUse?.copied_landuse
          }       
        </p>
          <div className="position-relative">
            {activeDropdown === filterName && (
              <div className="dropdown-menu show position-absolute mt-2 end-0 p-0 border-0">
                <ul className="list-unstyled m-0 bg-white border rounded shadow border-0">
                  <li
                    className="dropdown-item cursor-pointer px-3 py-2"
                    onClick={() => console.log("Edit clicked")}
                  >
                    Edit
                  </li>
                  <li
                    className="dropdown-item cursor-pointer  px-3 py-2"
                    onClick={() => console.log("Delete clicked")}
                  >
                    Delete
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="row filter-label">
          <div className="col-lg-12">
            <label> Land Usage</label>
            <div className="position-relative">
              <input
                type="text"
                placeholder="Enter Land usage"
                className="form-control"
                // onChange={(e) => handleFormChange("landUseValue", e.target.value)}
                // onChange={(e) => handleFormChange(filterName, "landUseValue", e.target.value)}
                value={formValues[filterName]?.landUseValue || ""}
                onChange={(e) =>
                  handleFormChange(filterName, "landUseValue", e.target.value)
                }
              />
              <div className="input-box-filter">
                <p className="mb-0">
                  {matchingLandUse ? (
                    <strong> ({matchingLandUse.unit}) </strong>
                  ) : (
                    " N/A"
                  )}
                </p>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4">
            <label> Captive Ratio </label>
            <input
              type="text"
              placeholder=""
              className="form-control"
              value={"100%"}
            />
          </div> */}
          {/* <div className="col-lg-4">
            <label> Driving Adjustment </label>
            <input
              type="text"
              placeholder=""
              className="form-control"
              value={"100%"}
            />
          </div> */}
        </div>
      </div>
    );
  };

  const handleFormFinish = async () => {
    // console.log("selectedValues From Calculate::",selectedValues);

    
    // const payload = {
    //     land_use_descriptions: selectedValues.map(value => [value, formValues.landUseDescription]),
    //     land_use_values: selectedValues.map(() => parseInt(formValues.landUseValue)),
    // };

    // Validate if Land Usage fields are empty
    const invalidLandUsage = selectedValues.some((value) => {
      const landUseValue = formValues[value]?.landUseValue;
      return !landUseValue || landUseValue.trim() === ""; // Check if Land Usage is empty
    });

    if (invalidLandUsage) {
      openNotification(
        "error",
        "Validation Failed",
        "Please fill out all Land Usage fields."
      );
      return; // Stop the submission if validation fails
    }

    // const land_use_unit = selectedValues.map((value) => {
    //   const matchingItem = landdescriptionResponse.find(
    //     (item) =>
    //       item["Land Use"] === value &&
    //       item["Land Use"] === value
    //   );
    //   return matchingItem ? matchingItem.unit : "<default unit>";
    // });

    // Map selected values to land_use_descriptions
    const land_use_descriptions = selectedValues.map((value) => {
      const matchingItem = landdescriptionResponse_category
        ?.flatMap((category) => category.land_uses || []) // Flatten all land_uses arrays
        .find((landUse) => landUse.land_use_name === value);

      return matchingItem
        ? [matchingItem.main_category, matchingItem.sub_category || "Typical"] // Default sub_category to "Typical" if null
        : [value, "Typical"]; // Fallback
    });

    // console.log("land_use_descriptions::",land_use_descriptions);
    


    const land_use_unit = selectedValues.map((value) => {
      // Find the matching land use in the landdescriptionResponse_category structure
      const matchingItem = landdescriptionResponse_category
        ?.flatMap((category) => category.land_uses || []) // Flatten all land_uses arrays
        .find(
          (landUse) =>
            landUse.land_use_name === value // Match by land_use_name
        );
      
      // Return the unit if a matching land use is found, or fallback to "<default unit>"
      return matchingItem ? matchingItem.unit : "<default unit>"; 
    });
    // console.log("land_use_unit",land_use_unit);
    
    // const land_use_values = selectedValues.map((value, index) => {
    //   let originalValue = parseInt(formValues[value]?.landUseValue) || 0;
    //   return land_use_unit[index] === "seats" || land_use_unit[index] === "acre"
    //     ? originalValue * 1000
    //     : originalValue;
    // });

    const payload = {
      // land_use_descriptions: selectedValues.map((value) => [
      //   value,
      //   value === "Retail" ? "<400 ksf" : "Typical", 
      // ]),
      land_use_descriptions,
      // land_use_values,
      land_use_values: selectedValues.map(
        (value) => parseInt(formValues[value]?.landUseValue) || 0
      ),
      land_use_unit,
    };
    dispatch(setPlanningBuildPayload(payload));

    console.log("payload::", payload);
    // console.log("formValues::", formValues);

    try {

  

      const graphDemandResponse = await post("graphdemandlatestdb", payload);
      // const graphDemandResponse = await post("http://192.168.96.120:5000/apis/graphdemandlatestdb", payload);


      // console.log("graphDemandResponse::",graphDemandResponse.data);
      // const overviewGraphDemandResponse = await post(
      //   "http://192.168.96.120:5000/apis/overviewgraphdemanddb",
      //   payload
      // );

      // console.log("graphDemandResponse::",graphDemandResponse.data);
      const overviewGraphDemandResponse = await post(
        "overviewgraphdemanddb",
        payload
      );



      // Navigate to the dashboard page with the response data
      navigate("/dashboard", {
        state: {
          selectedValues: selectedValues,
          parkingDemandData: graphDemandResponse.data,
          overviewGraphDemandData: overviewGraphDemandResponse.data,
          // parkingDemandData: parkingDemandResponse.data,
          // graphDemandData: graphDemandResponse.data
        },
      });
    } catch (error) {
      console.error("Error fetching parking demand data:", error);
    }
  };


  

  // console.log("selectedValues For Planning Building::::",selectedValues)
  // const onChange = (key) => {
  //     console.log(key);
  //   };
  //   const items = [
  //     {
  //       key: '1',
  //       label: 'This is panel header 1',
  //       children: <p>dfsdfgsdfg</p>,
  //     },
  //     {
  //       key: '2',
  //       label: 'This is panel header 2',
  //       children: <p>sdfdsfv</p>,
  //     },
  //     {
  //       key: '3',
  //       label: 'This is panel header 3',
  //       children: <p>sfgbgb</p>,
  //     },
  //   ];
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <>
      
          <div className="row">
            <div className="d-flex align-items-center">
              {/* {userCheck && <AdminSidebar />} */}
              <AdminSidebar />
              
              <div className="col-size-3">
              
                <div
                  className="inside-filter p-0"
                >
                  
                  <div
                    className="d-flex align-items-center"
                    style={{ padding: "20px 20px 0 20px" }}
                  >
                    <img src={FilterImg} alt="" />
                    <h5 className="mb-0 ms-2">Select Space</h5>
                  </div>
                  <div
                    className="my-3 d-flex align-items-center position-relative"
                    style={{ padding: "0px 5px 0 5px" }}
                  >
                    <span
                      className="position-absolute top-4"
                      style={{ left: "27px" }}
                    >
                      <img
                        src={SearchIconImg}
                        alt=""
                        style={{ width: "18px" }}
                      />
                    </span>

                    <input
                      type="search"
                      value={searchSpace}
                      onChange={(e) => handleSpaceSearch(e.target.value)}
                      className="form-control ps-5 mx-2"
                      placeholder="Search"
                    />
                  </div>
                  {/* // */}
                  {/* <div>
                            <div className="select-filter-leftside">
                                <Checkbox.Group
                                    style={{
                                        width: '100%',
                                    }}
                                    value={selectedValues}
                                    onChange={handleSelctingSpaceFromFilter}
                                >
                                    <Row className="flex-column">
                                       
                                        {filteredlandUsesQuery.map((lands,index)=>(
                                            <Col key={index} className="checkbox-rounded">
                                            <Checkbox value={lands}>{lands}</Checkbox>
                                            </Col>
                                        ))}
                                    </Row>
                                </Checkbox.Group>
                            </div>
                        </div> */}
                        {/* // */}
                  {/* <div>
                    <Collapse
                      onChange={onChange}
                      ghost
                      className="configuration-sidebar"
                      expandIcon={({ isActive }) =>
                        isActive ? <MinusOutlined /> : <PlusOutlined />
                      }
                    >
                      <Panel header="This is panel header 1" key="1">
                        <ul className="category-style">
                        {filteredlandUsesQuery.map((lands, index) => (
                            <li key={index} onClick={() => handleCategoryClick(lands)}>
                            <span className="category-list">{lands}</span>
                            {selectedCategories.includes(lands) && (
                                <span>
                                <img src={TickImgNew} alt="Selected" />
                                </span>
                            )}
                            </li>
                        ))}
                        </ul>
                    </Panel>
                    <Panel header="This is panel header 1" key="2">
                        <ul className="category-style">
                        {filteredlandUsesQuery.map((lands, index) => (
                            <li key={index} onClick={() => handleCategoryClick(lands)}>
                            <span className="category-list">{lands}</span>
                            {selectedCategories.includes(lands) && (
                                <span>
                                <img src={TickImgNew} alt="Selected" />
                                </span>
                            )}
                            </li>
                        ))}
                        </ul>
                    </Panel>
                    </Collapse>
                  </div> */}
                  
                  {/* // */}

                  {/* // */}
                  <div>
      {/* {loading ? (
        <p>Loading...</p>
      ) : ( */}
      
        <Collapse
          ghost
          className="configuration-sidebar"
          expandIcon={({ isActive }) => (isActive ? <MinusOutlined /> : <PlusOutlined />)}
        >
          {/* {landdescriptionResponse_category.map((category, categoryIndex) => ( */}
            {filteredlandUsesQuery.map((category, categoryIndex) => (
            <Panel header={category.category_name} key={categoryIndex}>
              <ul className="category-style">
                {category.land_uses.map((land) => (
                  <li key={land.land_use_id} title={land.land_use_name}
                  onClick={() => handleSelctingSpaceFromFilter(land.land_use_name)}
                   >
                    <span className="category-list">{land.land_use_name}</span>
                    {selectedValues.includes(land.land_use_name) && (
                      <span>
                        <img src={TickImgNew} alt="Selected" />
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </Panel>
          ))}
        </Collapse>
      {/* )} */}
     
    </div>
                  {/* // */}
                  
                </div>
                
              </div>

              <div className="col-size-5">
              {loading ? (
                    <div>
                      <Loading />
                    </div>
                  ) : (
                    <>
                <div
                  className="inside-filter"
                  style={{
                    overflow: selectedValues.length === 0 ? "hidden" : "auto",
                  }}
                >
                  {/* <h5>Selected Filters</h5>
                        
                        
                        <hr /> */}
                  <div className="d-flex align-items-center justify-content-between">
                    <h5>Selected Space({selectedValues.length})</h5>
                    {selectedValues.length !== 0 && (
                      <p>
                        <a href="" className="clear-all">
                          Clear All
                        </a>
                      </p>
                    )}
                  </div>
                  {selectedValues.length === 0 ? (
                    <div className="h-100 d-flex align-items-center justify-content-center flex-column">
                      {/* <div className="text-center">
                                <img src={NoBackgroundImage} alt="" className="w-50 rounded" />
                            </div> */}
                      <div className="w-100 text-center mt-3 heading-label">
                        <h1 className="mb-0">
                          <span className="typing line1">
                            Hi {admin_firstname},
                          </span>
                        </h1>
                        <h1>
                          <span className="typing line2">
                            Planning to build a Space?
                          </span>
                        </h1>
                      </div>
                      <div className="info-box">
                        <span>
                          <img src={InfoGreen} alt="" />
                        </span>
                        <p>
                          Please select the spaces listed from the left side
                        </p>
                      </div>
                    </div>
                  ) : (
                    selectedValues.map((filter) => renderFilterForm(filter))
                  )}
                </div>
                </>
                  )}
              </div>
              
            </div>
            
            <div className="col-lg-12 text-end pt-3">
            {selectedValues.length >0 &&(
              <button className="btn btn-primary" onClick={handleFormFinish}>
                Calculate
              </button>
               )}
            </div>
           
          </div>
          
       
    </>
  );
};

export default PlanningBuildFilter;
